import React, { useState } from "react";
import { auth } from "../../firebase";
import { updateUserProfileHandle } from "../../services/userProfileService";
import { Headings } from "../Headings";
import "./Step4SetHandle.scss";

interface Step4SetHandleProps {
  handle: string;
  onNext: () => void;
}

const Step4SetHandle: React.FC<Step4SetHandleProps> = ({ onNext, handle }) => {
  const [username, setUsername] = useState(handle);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const validateUsername = (value: string): boolean => {
    if (value.length < 4) {
      setError("Username must be at least 4 characters long.");
      return false;
    }
    if (!/^[a-zA-Z0-9_]+$/.test(value)) {
      setError(
        "Username can only contain alphanumeric characters and underscores."
      );
      return false;
    }
    setError(null);
    return true;
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!validateUsername(username)) {
      return;
    }

    const currentUser = auth.currentUser;
    if (!currentUser) {
      setError("No user is currently signed in.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await updateUserProfileHandle(currentUser.uid, username, 0);
      onNext();
    } catch (err) {
      setError("Failed to save username. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="step4-set-handle-container">
      <Headings.Modal>Set Your Handle</Headings.Modal>
      <div className="context">
        Choose a unique username for your profile. Your username and profile are
        the only public information displayed to other users on this site.
      </div>
      <form onSubmit={handleSubmit} className="set-handle-form">
        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            id="username"
            className="form-control"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              if (error) {
                validateUsername(e.target.value);
              }
            }}
            placeholder="Enter your username"
            aria-describedby="usernameError"
          />
          {error && (
            <p id="usernameError" className="error-message">
              {error}
            </p>
          )}
        </div>
        <button
          type="submit"
          disabled={loading || !!error}
          className="submit-button btn btn-primary"
        >
          {loading ? "Saving..." : "Save and Continue"}
        </button>
      </form>
    </div>
  );
};

export default Step4SetHandle;
